export enum LinkingMethod {
    AND = 'AND',
    OR = 'OR',
    XOR = 'XOR'
}
